import { FC, ReactNode } from 'react';
import { ListGroup } from 'react-bootstrap';

const List: FC<{ show: boolean; children: ReactNode }> = ({
  show,
  children,
}) => {
  return (
    <ListGroup
      className="position-absolute top-50 start-50 translate-middle text-uppercase"
      style={{
        opacity: show ? 1 : 0,
        transition: 'opacity 0.5s ease-in-out',
      }}
    >
      {children}
    </ListGroup>
  );
};

export default List;
